import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import "./../scss/index.scss";

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Experiencia Globant AI - Converge"
      meta={[
        { name: "description", content: "Experiencia Globant AI - Converge" },
        { name: "keywords", content: "Globant, minds, technology" }
      ]}
    />
    <div>
      {children()}
      <div className="footer">
        <div className="container">
          <div className="row centered">
            <h1>¡Gracias por acompañarnos!</h1>
            <h4>
              Esta experiencia fue posible gracias a{" "}
              <span className="fwsemibold">Globant Minds</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js